import { ArchivedIssuesList } from './ArchivedIssuesList';
import { PotentialIssuesHeader } from './PotentialIssuesHeader';
import React from 'react';
import { SnoozedIssuesList } from './SnoozedIssuesList';
import { VisibleIssuesList } from './VisibleIssuesList';
import { BASE_ROUTES, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { Navigate, Route, Routes } from 'react-router-dom';
import { SonarCard, ViewArea } from '@ui/general';
export const IssuesView = () => React.createElement(ViewArea, { direction: 'vertical', id: 'issues-view', showPeriscopes: true },
    React.createElement(SonarCard, { noSpacing: true, title: React.createElement(PotentialIssuesHeader, null) },
        React.createElement(Routes, null,
            React.createElement(Route, { element: React.createElement(VisibleIssuesList, null), path: '' }),
            React.createElement(Route, { element: React.createElement(ArchivedIssuesList, null), path: BASE_ROUTES.ARCHIVED }),
            React.createElement(Route, { element: React.createElement(SnoozedIssuesList, null), path: BASE_ROUTES.SNOOZED }),
            React.createElement(Route, { element: React.createElement(Navigate, { to: FULL_ROUTES.ISSUES }), path: '*' }))));
